<template>
    <v-app-bar color="#3D1159" dark :clipped-left="true" app :absolute="false">
        <v-app-bar-nav-icon @click.stop="$emit('toggle-drawer')"/>
        <v-img
            class="mx-1"
            src="@/assets/lyndus_logo.png"
            max-height="50"
            max-width="200"
            contain
        ></v-img>

        <v-toolbar-title class="black--text"></v-toolbar-title>

        <v-spacer></v-spacer>
        <span> <v-icon class="mr-2">mdi-account</v-icon> {{ currentUser }}</span>
    </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "AppHeader",
    computed: {
        ...mapGetters(["currentUser"]),
    }
};
</script> 